export const baseUrl = import.meta.env.VITE_API_URL;
export const platFormBaseUrl = import.meta.env.VITE_PLATFORM_API_URL;
export const apiconfig = import.meta.env.VITE_API_USER_CONFIG;
const ApiConfig = {
  // 登陆模块
  loginIn: `/${apiconfig}/user/login`,
  loginOut: `/${apiconfig}/user/logout`,
  getUserInfo: `/${apiconfig}/user/profile`,
  getUserInfoCn: `/${apiconfig}/user/profile`,
  // 对象存储模块
  getCosCred: "/api/cos-cred",
  getCosPathKey: "/api/upload-path",
  getOssCred: "/api/misc/cos-token",
  getOssPathKey: "/api/oss-upload-path",

};

export default ApiConfig;
